import React from "react";
import { Select } from "antd";
import ScrollDateInput from "../../calendar/ScrollDateInput";

const DIA_DESCANSO_OPTIONS = [
   { label: "Un dia a la semana", value: "Un dia a la semana" },
  { label: "Sin descanso", value: "Sin descanso" },
  { label: "Lunes", value: "Lunes" },
  { label: "Martes", value: "Martes" },
  { label: "Miércoles", value: "Miércoles" },
  { label: "Jueves", value: "Jueves" },
  { label: "Viernes", value: "Viernes" },
  { label: "Sábado", value: "Sábado" },
  { label: "Domingo", value: "Domingo" },
];

export default function CondicionesTrabajoSection({ fieldMeta, form, errors, setField }) {
  const diasDescanso = Array.isArray(form.dia_descanso) ? form.dia_descanso : [];

  const chip = (key, manual = false) => {
    if (manual) return <span className="oa-chip-manual">MANUAL</span>;
    const m = fieldMeta?.(key);
    if (!m) return null;
    if (m.needsReview) return <span className="oa-tag-review" title={m.reviewReason}><span className="material-symbols-outlined" style={{ fontSize: 11, verticalAlign: "middle" }}>warning</span> REVISAR</span>;
    if (m.isAI) return <span className="oa-chip-ai">IA</span>;
    return null;
  };
  const fw = (key) => `oa-field${fieldMeta?.(key)?.needsReview ? " oa-field-review" : ""}`;

  const handleDiaDescansoChange = (values) => {
    let next = Array.isArray(values) ? values : [];

    if (next.includes("Sin descanso")) {
      next = ["Sin descanso"];
    }

    setField("dia_descanso", next);
  };

  return (
    <section className="oa-card">
      <div className="oa-card-head">
        <h2 className="oa-card-title">
          <span className="oa-card-icon">
            <i className="fa-solid fa-file-contract" />
          </span>
          CONDICIONES GENERALES DE TRABAJO RECLAMADOS POR LA PARTE ACTORA
        </h2>
      </div>

      <div className="oa-card-body oa-grid-3">
        <div className={fw("fecha_ingreso")}>
          <label className="oa-label">Fecha de Ingreso {chip("fecha_ingreso")}</label>
          <ScrollDateInput
            style={{ width: "100%" }}
            value={form.fecha_ingreso}
            onChange={(v) => setField("fecha_ingreso", v)}
          />
          {errors.fecha_ingreso ? <div className="oa-error">{errors.fecha_ingreso}</div> : null}
        </div>

        <div className={fw("fecha_ultimo_dia_laborado")}>
          <label className="oa-label">Último Día Laborado {chip("fecha_ultimo_dia_laborado")}</label>
          <ScrollDateInput
            style={{ width: "100%" }}
            value={form.fecha_ultimo_dia_laborado}
            onChange={(v) => setField("fecha_ultimo_dia_laborado", v)}
          />
          {errors.fecha_ultimo_dia_laborado ? <div className="oa-error">{errors.fecha_ultimo_dia_laborado}</div> : null}
        </div>

        <div className={fw("puesto")}>
          <label className="oa-label">Puesto o Categoría {chip("puesto")}</label>
          <input
            className={`oa-input ${errors.puesto ? "oa-input-error" : ""}`}
            type="text"
            placeholder="Ej. Operador"
            value={form.puesto}
            onChange={(e) => setField("puesto", e.target.value)}
          />
          {errors.puesto ? <div className="oa-error">{errors.puesto}</div> : null}
        </div>

        <div className={fw("salario_diario")}>
          <label className="oa-label">Salario Diario {chip("salario_diario")}</label>
          <div className={`oa-money ${errors.salario_diario ? "oa-input-error" : ""}`}>
            <span className="oa-money-prefix">$</span>
            <input
              className="oa-money-input"
              type="number"
              step="0.01"
              placeholder="0.00"
              value={form.salario_diario}
              onChange={(e) => setField("salario_diario", e.target.value)}
            />
          </div>
          {errors.salario_diario ? <div className="oa-error">{errors.salario_diario}</div> : null}
        </div>

        <div className={fw("salario_diario_integrado")}>
          <label className="oa-label">Salario Diario Integrado {chip("salario_diario_integrado")}</label>
          <div className={`oa-money ${errors.salario_diario_integrado ? "oa-input-error" : ""}`}>
            <span className="oa-money-prefix">$</span>
            <input
              className="oa-money-input"
              type="number"
              step="0.01"
              placeholder="0.00"
              value={form.salario_diario_integrado}
              onChange={(e) => setField("salario_diario_integrado", e.target.value)}
            />
          </div>
          {errors.salario_diario_integrado ? <div className="oa-error">{errors.salario_diario_integrado}</div> : null}
        </div>

        <div className={fw("jornada")}>
          <label className="oa-label">Jornada de Trabajo {chip("jornada")}</label>
          <input
            className={`oa-input ${errors.jornada ? "oa-input-error" : ""}`}
            type="text"
            placeholder=""
            value={form.jornada}
            onChange={(e) => setField("jornada", e.target.value)}
          />
          {errors.jornada ? <div className="oa-error">{errors.jornada}</div> : null}
        </div>

        <div className={fw("dia_descanso")}>
          <label className="oa-label">Día(s) de Descanso {chip("dia_descanso")}</label>
          <Select
            mode="multiple"
            allowClear
            placeholder="Seleccionar día(s)"
            value={diasDescanso}
            onChange={handleDiaDescansoChange}
            options={DIA_DESCANSO_OPTIONS}
            className={errors.dia_descanso ? "oa-ant-select-error" : ""}
            style={{ width: "100%" }}
          />
          {errors.dia_descanso ? <div className="oa-error">{errors.dia_descanso}</div> : null}
        </div>

        <div className={fw("lugar_servicio")}>
          <label className="oa-label">Lugar de Prestación del Servicio {chip("lugar_servicio")}</label>
          <input
            className={`oa-input ${errors.lugar_servicio ? "oa-input-error" : ""}`}
            type="text"
            placeholder="Domicilio completo del centro de trabajo"
            value={form.lugar_servicio}
            onChange={(e) => setField("lugar_servicio", e.target.value)}
          />
          {errors.lugar_servicio ? <div className="oa-error">{errors.lugar_servicio}</div> : null}
        </div>

        <div className={fw("hechos")}>
          <label className="oa-label">Circunstancias de Modo, Tiempo y Lugar {chip("hechos")}</label>
          <textarea
            className={`oa-input ${errors.hechos ? "oa-input-error" : ""}`}
            rows={8}
            value={form.hechos}
            onChange={(e) => setField("hechos", e.target.value)}
          />
          {errors.hechos ? <div className="oa-error">{errors.hechos}</div> : null}
        </div>
      </div>
    </section>
  );
}
